// extracted by mini-css-extract-plugin
export default {"container":"Home_container__AhiAA","name":"Home_name__QSGC6","role":"Home_role__kzsoi"};